import {Pipe, PipeTransform} from '@angular/core';

@Pipe({name: 'localeLowerCase'})
export class LocaleLowerCase implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    return (value as string).toLocaleLowerCase();
  }
}
